import { useQuery } from '@tanstack/react-query';

import { useLogErrorPublicWeb } from '@telialt/utils/src/datadog/useLogError';

import { loadBreadcrumbsDataFromLanding } from '../api';
import { QUERY_KEY } from '../constants';

export const useLandingDataQuery = (routes: string[]) => {
    const {
        data: landingData,
        isLoading: isLoadingLandingData,
        isError: isErrorLandingData,
        error: errorLandingData,
    } = useQuery({
        queryKey: [QUERY_KEY.LANDING_DATA, routes],
        queryFn: () => loadBreadcrumbsDataFromLanding(routes),
        enabled: routes.length > 0,
    });
    useLogErrorPublicWeb(errorLandingData);

    return { landingData, isLoadingLandingData, isErrorLandingData, errorLandingData };
};
